import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
    return (
       <div>
        <footer>
<div class="container">
<div class="row text-center">
	<div class="col-md-4 footer-text">
		<br />
		<img src={"./img/logo-footer.png"}/>
		<hr class="light"/>
		<p>Techarabiya is a fast-growing “Software House” that proudly deals in Fintech and Digital Solutions. </p>
		
	</div>
	<div class="col-md-4 footer-text">
		
		<h5>Our Links</h5>
		<hr color="white"/>
		<p><Link to="/About" >About Us</Link></p>
		<p><Link to="/Services" >Services</Link></p>
		<p><Link to="/Industries">Industries</Link></p>
		<p><Link to="/TechnologyStack">Technology Stack</Link></p>
		<p><Link to="/ContactUs">Contact Us</Link></p>
		
	</div>
	<div class="col-md-4 footer-text">
		
		<h5>Our Address</h5>
		<hr color="white"/>
		<p>New York
235 Mamaroneck Ave, Suite #301,
White Plains, NY 10605</p>
		<p>Phone: +1 (914) 615-9170</p>
		<p>Email: info@techarabiya.com</p>
		<br />

	
	</div>
	<div class="col-12 footer-text">
		<hr color="grey" />
		<p>&copy; 2020 techarabiya.com</p>
		
	</div>
	
</div>	
</div>
</footer>
</div>

    )
}

export default Footer
